import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AgroOverviewLayersState,
  AgroOverviewVariable,
  LocationsSortKey,
  SortDirection,
} from 'types/Meteorology/Agro/Overview/Dashboard';

interface AgroOverviewDashboardState {
  selectedVariable: AgroOverviewVariable;
  layers: AgroOverviewLayersState;
  tableSortBy: LocationsSortKey;
  tableSortDirection: SortDirection;
  tableSearch: string;
}

const initialState: AgroOverviewDashboardState = {
  selectedVariable: 'arm',
  layers: {
    localidades: true,
    alertas: true,
    limitesEstaduais: true,
    exibirVariavel: true,
  },
  tableSortBy: 'diasSemChuva',
  tableSortDirection: 'desc',
  tableSearch: '',
};

const slice = createSlice({
  name: 'meteorologyAgroOverviewDashboard',
  initialState,
  reducers: {
    setSelectedVariable: (state, action: PayloadAction<AgroOverviewVariable>) => {
      state.selectedVariable = action.payload;
      // Regra de negócio (pedido da Bruna em 26/08/2026): o cliente não lembra
      // que ocultou e acharia que a variável nova não tem dado. Fica no reducer
      // para valer em qualquer origem da troca, não só no dropdown.
      state.layers.exibirVariavel = true;
    },
    toggleLayer: (state, action: PayloadAction<keyof AgroOverviewLayersState>) => {
      state.layers[action.payload] = !state.layers[action.payload];
    },
    setTableSortBy: (state, action: PayloadAction<LocationsSortKey>) => {
      state.tableSortBy = action.payload;
    },
    setTableSortDirection: (state, action: PayloadAction<SortDirection>) => {
      state.tableSortDirection = action.payload;
    },
    setTableSearch: (state, action: PayloadAction<string>) => {
      state.tableSearch = action.payload;
    },
  },
});

/* eslint-disable @typescript-eslint/no-explicit-any */
export const selectAgroOverviewSelectedVariable = (state: any): AgroOverviewVariable => (
  state.meteorologyAgroOverviewDashboard.selectedVariable
);
export const selectAgroOverviewLayers = (state: any): AgroOverviewLayersState => (
  state.meteorologyAgroOverviewDashboard.layers
);
export const selectAgroOverviewTableSortBy = (state: any): LocationsSortKey => (
  state.meteorologyAgroOverviewDashboard.tableSortBy
);
export const selectAgroOverviewTableSortDirection = (state: any): SortDirection => (
  state.meteorologyAgroOverviewDashboard.tableSortDirection
);
export const selectAgroOverviewTableSearch = (state: any): string => (
  state.meteorologyAgroOverviewDashboard.tableSearch
);
/* eslint-enable @typescript-eslint/no-explicit-any */

export const {
  setSelectedVariable,
  toggleLayer,
  setTableSortBy,
  setTableSortDirection,
  setTableSearch,
} = slice.actions;

export default slice.reducer;
